export default "__VITE_ASSET__BjDkNy7l__"